import { Div, createEmitter } from '@codesuma/baseline'
import { IconPicker } from '../../../components/icon-picker'
import style from './index.module.css'

// Bottom-sheet icon picker: the New List wizard's icon grid, with the list's
// current icon ringed. Emits 'pick' (the icon key) and 'close'. Overlay
// conventions: body-level, safe-area bottom padding, back closes it via a
// state-only history marker (see share-panel).
export const IconPanel = () => {
    const emitter = createEmitter()

    const overlay = Div()
    overlay.addClass(style.overlay)

    const panel = Div()
    panel.addClass(style.panel)
    overlay.append(panel)

    // Back = close (same marker pattern as the share panel).
    let markerLive = false
    const onPop = () => {
        window.removeEventListener('popstate', onPop)
        markerLive = false
        emitter.emit('close')
    }
    const requestClose = () => {
        if (markerLive) {
            markerLive = false
            history.back() // onPop delivers the actual 'close'
        } else {
            emitter.emit('close')
        }
    }
    overlay.el.onclick = (e: MouseEvent) => {
        if (e.target === overlay.el) requestClose()
    }

    const show = (current: string) => {
        // Built fresh every show (baseline empty() is permanent for reused
        // children, so no instance is ever reused across shows).
        panel.empty()
        const picker = IconPicker(current)
        picker.on('pick', (key: string) => {
            emitter.emit('pick', key)
            requestClose()
        })
        panel.append(picker)
        panel.el.scrollTop = 0

        if (!markerLive) {
            history.pushState({ iconPanel: true }, '')
            markerLive = true
            window.addEventListener('popstate', onPop)
        }
    }

    return Object.assign(overlay, {
        on: emitter.on.bind(emitter),
        show,
    })
}
